// IMPORT VENDOR
import $ from "jquery";
window.$ = window.jQuery = $;

import { Foundation } from "foundation-sites/js/foundation.core";
//import { Reveal } from "foundation-sites/js/foundation.reveal";
Foundation.addToJquery($);
//Foundation.plugin(Reveal, "Reveal");
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.plugin(MediaQuery, 'MediaQuery');

// IMPORT DES COMPONENTS
//import { utils } from "./components/_utils";

// IMPORT DES PAGES
import { frontPage } from "./pages/front-page";
import { cave } from "./pages/cave";
import { faq } from "./pages/faq";
import { contact } from "./pages/contact";


// ----------------------------------- DOCUMENT READY -----------------------------------
// --------------------------------------------------------------------------------------
jQuery(function () {
  let bodyClassList = document.getElementsByTagName("body")[0].classList;
  switch (true) {
    case bodyClassList.contains("page-template-front-page"):
      frontPage.readyFn();
      break;
    case bodyClassList.contains("page-template-page-cave"):
      cave.readyFn();
      break;
    case bodyClassList.contains("page-template-page-faq"):
      faq.readyFn();
      break;
    case bodyClassList.contains("page-template-page-contact"):
      contact.readyFn();
      break;
  }
});

// ----------------------------------- WINDOW LOAD --------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("load", function () {

  $(document).foundation();

  $("#nav-toggle").on("click", function (e) {
    e.preventDefault();
    $("#mobile-menu").slideToggle("fast");
    $("#overlay").fadeToggle("fast");
    $(this).toggleClass("active");
  });

  $("#mobile-menu a").on("click", function (e) {
    $("#mobile-menu").slideToggle("fast");
    $("#nav-toggle").toggleClass("active");
  });

  const swiper = new Swiper('.swiper-container', {
    // Optional parameters
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  $(".link-dore").hover(function () {
    $(".arrow", this).addClass("arrow-hovered");
  }, function () {
    $(".arrow", this).removeClass("arrow-hovered");
  });

  jQuery('img.svg').each(function () {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function (data) {
      // Get the SVG tag, ignore the rest
      var $svg = jQuery(data).find('svg');

      // Add replaced image's ID to the new SVG
      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');

  });

});

// ----------------------------------- WINDOW RESIZE ------------------------------------
// --------------------------------------------------------------------------------------
$(window).on("resize", function () { });
